import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import OvCompactButton from '../atoms/OvCompactButton';
import OvErrorMessage from '../atoms/OvErrorMessage';
import { useAdminVideoMutations } from '../../../hooks/use-admin-video-mutations';
import { getHttpStatus } from '../../../common/utils/http-status';

interface OvVideoProcessingRetryProps {
  videoId: string;
}

const OvVideoProcessingRetry: FC<OvVideoProcessingRetryProps> = ({
  videoId,
}) => {
  const { t } = useTranslation();
  const { retry } = useAdminVideoMutations();

  return (
    <>
      <OvCompactButton
        tone="secondary"
        isBusy={retry.isPending}
        busyLabel={t('videos.details.retrying')}
        onClick={() => retry.mutate(videoId)}
      >
        {t('common.actions.retry')}
      </OvCompactButton>
      {retry.isError && (
        <OvErrorMessage
          message={t(
            getHttpStatus(retry.error) === 409
              ? 'videos.details.retryConflict'
              : 'videos.details.retryFailed'
          )}
        />
      )}
    </>
  );
};

export default OvVideoProcessingRetry;
